/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_No_Client_BodyInputs */

const en_portal_no_client_body = /** @type {(inputs: Portal_No_Client_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These pages show one client's portal. Preview it as one of your clients, and you will see exactly what they see.`)
};

/** @type {(inputs: Portal_No_Client_BodyInputs) => LocalizedString} */
const ar_portal_no_client_body = en_portal_no_client_body;

/** @type {(inputs: Portal_No_Client_BodyInputs) => LocalizedString} */
const he_portal_no_client_body = en_portal_no_client_body;

/** @type {(inputs: Portal_No_Client_BodyInputs) => LocalizedString} */
const ur_portal_no_client_body = en_portal_no_client_body;

/** @type {(inputs: Portal_No_Client_BodyInputs) => LocalizedString} */
const es_portal_no_client_body = en_portal_no_client_body;

/** @type {(inputs: Portal_No_Client_BodyInputs) => LocalizedString} */
const fr_portal_no_client_body = en_portal_no_client_body;

/** @type {(inputs: Portal_No_Client_BodyInputs) => LocalizedString} */
const de_portal_no_client_body = en_portal_no_client_body;

/** @type {(inputs: Portal_No_Client_BodyInputs) => LocalizedString} */
const pt_portal_no_client_body = en_portal_no_client_body;

/** @type {(inputs: Portal_No_Client_BodyInputs) => LocalizedString} */
const hi_portal_no_client_body = en_portal_no_client_body;

/** @type {(inputs: Portal_No_Client_BodyInputs) => LocalizedString} */
const bn_portal_no_client_body = en_portal_no_client_body;

/**
* | output |
* | --- |
* | "These pages show one client's portal. Preview it as one of your clients, and you will see exactly what they see." |
*
* @param {Portal_No_Client_BodyInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portal_no_client_body = /** @type {((inputs?: Portal_No_Client_BodyInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_No_Client_BodyInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portal_no_client_body(inputs)
	if (locale === "he") return he_portal_no_client_body(inputs)
	if (locale === "ur") return ur_portal_no_client_body(inputs)
	if (locale === "es") return es_portal_no_client_body(inputs)
	if (locale === "fr") return fr_portal_no_client_body(inputs)
	if (locale === "de") return de_portal_no_client_body(inputs)
	if (locale === "pt") return pt_portal_no_client_body(inputs)
	if (locale === "hi") return hi_portal_no_client_body(inputs)
	if (locale === "bn") return bn_portal_no_client_body(inputs)
	return /** @type {LocalizedString} */ ("These pages show one client's portal. Preview it as one of your clients, and you will see exactly what they see.")
});